// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".socialicon {\n  height: 20px;\n}\n#hero.hero {\n  background-image: url(\"/img/hero.png\");\n  background-position: center;\n  background-repeat: no-repeat;\n  background-size: cover;\n  position: relative;\n  height: 700px;\n}\n#nav {\n  background: none;\n  padding: 1.5em 2em 0;\n}\n#center {\n  flex: 1;\n  justify-content: center;\n  padding-left: 130px;\n}\n#copy {\n  font-size: 0.75em;\n  padding: 1rem 0.75rem;\n}\n#spacer {\n  min-height: 16rem;\n}", ""]);
// Exports
module.exports = exports;
